import type { ReactNode } from 'react';

export function StatusBar({ left, center, right }: { left: ReactNode; center?: ReactNode; right?: ReactNode }) {
  return (
    <footer className="status-bar text-meta">
      <div className="status-bar__left">{left}</div>
      {center && <div className="status-bar__center">{center}</div>}
      <div className="status-bar__right">{right}</div>
    </footer>
  );
}
